import { render, staticRenderFns } from "./HubButton.vue?vue&type=template&id=6c071d72&scoped=true&"
import script from "./HubButton.vue?vue&type=script&lang=ts&"
export * from "./HubButton.vue?vue&type=script&lang=ts&"
import style0 from "./HubButton.vue?vue&type=style&index=0&id=6c071d72&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c071d72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
